



























































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { YKDCenterDrawer } from 'gum-ui'

import {
  Department,
  DepartmentMap,
  PagingAccount,
  DepartmentAccountParam
} from '@/model/department/department'
import { Company, fetchAccountWithoutRedirect, Account } from 'ykd-base/account'
import { getAllDepartment, queryByKeyword } from '@/api/department/department'
import { Tree, Input } from 'ant-design-vue'
import { queryDepAccounts } from '@/api/department/department'
import { NewPage } from '@/model/common/newPage'

import {
  saveDepartment,
  convertDepartmentToMap,
  queryDepartmentAccounts
} from '@/api/department/department'

import { searchAccounts, QueryAccountPagingParam } from '@/api/account/account'

interface TreeData extends Department {
  key: string
  title: string
  scopedSlots: any
}

@Component({
  components: { YKDCenterDrawer, 'a-tree': Tree, 'a-input-search': Input }
})
export default class OrgTreeCenter extends Vue {
  @Prop()
  centerDrawer?: boolean

  private inputKeyWord: string = ''

  private companyId: string = ''
  private selectedKeys: string[] = []
  private expandedKeys: string[] = []

  private departmentTree!: TreeData[]
  private searchResultKeys: string[] = []

  private pageAccount: NewPage<Account> = {}

  private accounts: Account[] = []

  private demoAccounts: Account[] = []

  private loading: boolean = false

  private canLoad: boolean = true

  private departmentIds: string[] = []

  private checkedDepartmentKeys: string[] = []

  private checkedAccounts: Account[] = []

  private paging: boolean = true

  //store数据迁移
  private treeData: Department[] = []
  private departmentMap: DepartmentMap = {}

  private departmentAccountParam: DepartmentAccountParam = {
    departmentId: '',
    pagination: 0,
    pageSize: 15
  }

  private accountParam: QueryAccountPagingParam = {
    pagination: 0,
    pageSize: 15,
    name: '',
    companyId: ''
  }

  private columns = [
    {
      title: '姓名',
      dataIndex: 'user.userName',
      key: 'name'
    }
  ]
  private selectedTableKeys: any[] = []

  @Watch('centerDrawer', {
    immediate: true
  })
  onchange() {
    if (this.centerDrawer && this.paging === true) {
      let that = this
      this.$nextTick(() => {
        document
          .querySelector('.table-exam-plan-account .ant-table-body')!
          .addEventListener('scroll', async function() {
            const wrapper = document.querySelector(
              '.table-exam-plan-account .ant-table-tbody'
            )
            const container = document.querySelector(
              '.table-exam-plan-account .ant-table-body'
            )

            if (
              wrapper!.clientHeight -
                container!.scrollTop -
                container!.clientHeight <
                100 &&
              that.departmentAccountParam.pagination <
                that.pageAccount.totalPage!
            ) {
              that.departmentAccountParam.pagination =
                that.pageAccount.pagination! + 1
              if (that.canLoad) {
                that.canLoad = false
                await that.getAccounts()
                that.canLoad = true
              }
            }
          })
      })
    }
  }

  @Watch('selectedKeys')
  async changeDepartmentAccouts() {
    if (this.selectedKeys.length > 0) {
      this.demoAccounts = []
      this.departmentAccountParam.departmentId = this.selectedKeys[0]
      this.departmentAccountParam.pagination = 0
      const pageAccount: NewPage<Account> = await queryDepAccounts(
        this.departmentAccountParam
      )
      if (pageAccount && pageAccount.data && pageAccount.data.length > 0) {
        this.demoAccounts = pageAccount.data
        this.pageAccount = pageAccount
      } else {
        this.demoAccounts = []
      }
    }
  }

  async getAccounts() {
    this.loading = true
    if (this.paging === true) {
      this.pageAccount = await queryDepAccounts(this.departmentAccountParam)

      if (this.pageAccount && this.pageAccount.data) {
        Array.prototype.push.apply(this.demoAccounts, this.pageAccount.data)
      }
    } else {
      const accounts = await searchAccounts(this.accountParam)
      if (accounts && accounts.length > 0) {
        Array.prototype.push.apply(this.demoAccounts, accounts)
      }
    }
    this.loading = false
  }

  async mounted() {
    let account: Account = await fetchAccountWithoutRedirect()
    this.companyId = account.companyId
    // await this.initDepartment(this.companyId)

    const department = await getAllDepartment(this.companyId)
    this.treeData = [department]

    convertDepartmentToMap(department, this.departmentMap)

    this.onTreeData()
    // this.selectDepartment(this.treeData[0].id)
    this.selectedKeys = [this.treeData[0].id!]
    this.expandedKeys = [this.treeData[0].id!]
    this.accountParam.companyId = this.companyId
    this.departmentAccountParam.departmentId = this.treeData[0].id!
    await this.getAccounts()
  }

  onTreeData() {
    this.departmentTree = []
    this.initTree(this.treeData, this.departmentTree)
  }

  initTree(items: Department[], selectTreeData: TreeData[]) {
    items.map(node => {
      const item = {
        ...node,
        title: node.name,
        key: node.id!,
        scopedSlots: {
          icon: 'custom',
          key: node.id,
          title: node.name
        }
      } as TreeData
      selectTreeData.push(item)
      if (node.children && node.children.length > 0) {
        item.children = []
        this.initTree(node.children, item.children as TreeData[])
      }
    })
  }

  selectTreeNode(selectedKey: any[], e: any) {
    if (selectedKey && selectedKey.length > 0) {
      // this.selectDepartment(selectedKey[0])
      this.selectedKeys = selectedKey
      this.expandedKeys = selectedKey
    }
  }

  onSelectChange(selectedTableKeys: any) {
    this.selectedTableKeys = selectedTableKeys
  }

  onAccountChange(record: any, selected: any, selectedRows: any) {
    const accountIds = this.checkedAccounts.map(account => account.id)
    if (selected) {
      if (accountIds.indexOf(record.id) < 0) {
        this.checkedAccounts.push(record)
      }
    } else {
      if (accountIds.indexOf(record.id) >= 0) {
        this.checkedAccounts.splice(accountIds.indexOf(record.id), 1)
      }
    }
  }

  onSelectAllAccount(
    selected: any,
    record: Account[],
    selectedRows: Account[]
  ) {
    const accountIds = this.checkedAccounts.map(account => account.id)

    if (selected === true && record.length > 0) {
      record.forEach(account => {
        if (accountIds.indexOf(account.id) < 0) {
          this.checkedAccounts.push(account)
        }
      })
    } else {
      let accounts: Account[] = []
      this.checkedAccounts.forEach(account => {
        if (this.selectedTableKeys.indexOf(account.id) >= 0) {
          accounts.push(account)
        }
      })
      this.checkedAccounts = accounts
    }
  }

  deleteAll() {
    this.selectedTableKeys = []
    this.checkedAccounts = []
  }

  deleteSingle(id: string) {
    let accoutns: Account[] = []
    for (let i = 0; i < this.checkedAccounts.length; i++) {
      if (this.checkedAccounts[i].id !== id) {
        accoutns.push(this.checkedAccounts[i])
      }
    }
    this.checkedAccounts = accoutns

    let ids: string[] = []
    for (let i = 0; i < this.selectedTableKeys.length; i++) {
      if (this.selectedTableKeys[i] !== id) {
        ids.push(this.selectedTableKeys[i])
      }
    }
    this.selectedTableKeys = ids
  }

  closeCenter() {
    this.selectedTableKeys = []
    this.checkedAccounts = []
    this.departmentAccountParam.pagination = 0
    this.departmentAccountParam.pagination = 0
    this.$emit('closeCenter')
  }
  confirm() {
    this.$emit('confirm', this.checkedAccounts)
    this.closeCenter()
  }

  async handleChange(e: any) {
    this.inputKeyWord = e.target.value
    if (this.inputKeyWord) {
      this.paging = false
    } else {
      this.paging = true
      await this.changeDepartmentAccouts()
    }
    this.demoAccounts = []
    this.accountParam.companyId = this.companyId
    this.accountParam.pagination = 0
    this.accountParam.name = this.inputKeyWord
    await this.getAccounts()
  }
}
